import React from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/public/Header/PublicHeader';
import PublicFooter from '../../components/public/Footer/PublicFooter';
import PublicBetaNotice from './PublicBetaNotice';
import usePublicTheme from '../../hooks/usePublicTheme';
import styles from './LegalPage.module.css';

const PublicBetaNoticePage = ({ title, lastUpdated }) => {
  const { theme } = usePublicTheme();

  return (
    <div className={styles.pageContainer} data-theme={theme}>
      <PublicHeader />
      <main className={styles.mainContent}>
        <div className={styles.container}>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.lastUpdated}>Last updated: {lastUpdated}</p>
          <PublicBetaNotice />
          <Link to="/" className={styles.backLink}>
            &larr; Back to Home
          </Link>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
};

export default PublicBetaNoticePage;
